import { toDesignButton } from '@/lib/transformers'
import {
  Typo3SectionSpotHeadlessFeature,
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityContentShop,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityEventTop,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityPressroom,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices,
  Typo3SectionSpotSanityStory,
  Typo3SectionSpotSanityTour
} from '@/types/typo3'
import { SectionFeatureProps } from '@/ui/Sections/SectionFeature/type'

const toSectionFeature = (
  data:
    | Typo3SectionSpotSanityContentShop
    | Typo3SectionSpotSanityEventTop
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotSanityStory
    | Typo3SectionSpotSanityPressroom
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotHeadlessFeature
    | Typo3SectionSpotSanityEventList
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanityTour
) => {
  const { type } = data

  let sectionData = {
    section: data,
    overline: data?.content?.overline,
    title: data?.content?.title,
    titleLayout: data.content?.titleLayout,
    buttons: data.content?.buttons?.map((btn) => toDesignButton(btn)),
    items: []
  } as unknown as SectionFeatureProps

  if (type == 'spotheadless_feature') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.id || '',
        title: item.title,
        overline: item?.overline,
        description: item.text,
        link: {
          href: item?.link?.href,
          target: item?.link?.target,
          title: item?.link?.title
        },
        image: item?.images ? item?.images[0] : undefined
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_content_shop') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item.title,
        subTitle: ``,
        chips: item?.namesShopCategory,
        priceTextInfo: item?.infoPrice,
        priceText: item?.priceText,
        text: null,
        location: item.location,
        link: item?.link,
        image: item?.images ? item?.images[0] : undefined,
        openings: null,
        coordinates: null
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_story') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item?.contentTeaser?.title,
        text: item.contentTeaser?.author && `- ${item.contentTeaser?.author}`,
        link: item?.link,
        image: item?.images ? item?.images[0] : undefined
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_pressroom') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item?.contentTeaser?.title,
        text: item.contentTeaser?.summary,
        link: item?.link,
        date: item?.infoPublicationDate,
        image: item?.images ? item?.images[0] : undefined
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_eventtop') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item.title,
        subTitle: ``,
        date: item?.textDates?.[0]?.interval,
        cardDate: item?.textDates?.[0]?.firstActive,
        text: item.summary,
        location: item.infoLocation,
        link: {
          href: item?.link?.href,
          target: item?.link?.target,
          title: item?.link?.title
        },
        isTopEvent: item.isTopEvent,
        image: item?.images ? item?.images[0] : undefined,
        openings: item?.textDates,
        coordinates: item?.coordinates
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_eventlist') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item.title,
        //subTitle: item?.summary,
        date: item?.textDates?.[0]?.firstActiveWithYear,
        cardDate: item?.cleanDates?.[0]?.startDate,
        text: item?.summary,
        priceTextInfo: item?.prices?.[0]?.labelTitlePrice,
        priceText: item?.prices?.[0]?.labelPrice,
        location: item?.infoLocation,
        link: {
          href: item?.link?.href,
          target: item?.link?.target,
          title: item?.link?.title
        },
        isTopEvent: item.isTopEvent,
        image: item?.images ? item?.images[0] : undefined,
        coordinates: item?.coordinates
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_eatdrink') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item.title,
        subTitle: item?.summary,
        description: item.leadText,
        coordinates: item?.coordinates?.hasCoordinates
          ? {
              latitude: Number(item?.coordinates?.latitude),
              longitude: Number(item?.coordinates?.longitude)
            }
          : null,
        link: item?.link,
        image: item?.images ? item?.images[0] : undefined,
        openings: item?.openings,
        todayOpen: item?.todayOpen
      }))
    } as SectionFeatureProps
  } else if (type == 'spotsanity_tour') {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item?.uid,
        title: item?.title,
        description: item?.summary,
        distance: item?.distance,
        link: {
          href: item?.link?.href,
          title: item?.link?.title,
          target: item?.link?.target
        },
        image: item?.images ? item?.images[0] : undefined,
        tourInfo: {
          difficulty: item?.difficulty,
          difficultyLabel: item?.difficultyLabel,
          isStatusClosed: item?.isStatusClosed,
          isStatusOpen: item?.isStatusOpen,
          distance: item?.distanceFormatted,
          duration: item?.durationFormatted,
          altitudeUphill: item?.maxAltitude,
          altitudeDownhill: item?.minAltitude
        }
      }))
    } as SectionFeatureProps
  } else if (
    type == 'spotsanity_shopping' ||
    type == 'spotsanity_freetime' ||
    type == 'spotsanity_nature' ||
    type == 'spotsanity_service' ||
    type == 'spotsanity_sportservice' ||
    type == 'spotsanity_cultureandarchitecture' ||
    type == 'spotsanity_sportinfrastructure'
  ) {
    sectionData = {
      ...sectionData,
      items: data.content?.items?.map((item) => ({
        id: item.uid || '',
        title: item?.title,
        subTitle: item?.summary,
        link: {
          href: item?.slug,
          label: item?.link?.title,
          target: item?.link?.target
        },
        image: item?.images ? item?.images[0] : undefined,
        openings: item?.openings,
        todayOpen: item?.todayOpen
      }))
    } as SectionFeatureProps
  }

  return sectionData
}

export default toSectionFeature
